import { of, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { RecordingService } from '../services';
import { State } from '../services/work.state';

export const pauseMonitor = (recordingSvc: RecordingService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.system?.pauseMonitor !== undefined) {
        recordingSvc.pauseMonitor = state.system?.pauseMonitor;
        const newState = {
          ...state,
          ...{
            //pauseMonitor: state.system?.pauseMonitor,
            system: {
              ...state.system,
              ...{
                pauseMonitor: undefined,
              },
            },
          },
        };
        return of([newState, currentState] as [Partial<State>, State]);
      }

      return of([state, currentState] as [Partial<State>, State]);
    })
  );
